module.exports = __webpack_public_path__ + "img/h-led1.9070eb93.png";